export interface Bono {
  id: string
  label: string
  title: string
  value: string
  lead: string
  bullets: string[]
}

export const bonos: Bono[] = [
  {
    id: 'bono-1',
    label: 'Bono 1',
    title: 'Checklist “Ready to Fly”',
    value: '$29',
    lead: 'Previene el 90% de los desastres en vuelo. Imprímelo, plastifícalo y úsalo en cada operación.',
    bullets: [
      'Pre-vuelo: qué revisar 20 minutos antes de despegar',
      'Encendido secuencial sin fallos de comunicación',
      'Monitoreo continuo: qué buscar cada minuto en vuelo',
      'Aterrizaje y post-vuelo: cuidado de batería',
    ],
  },
  {
    id: 'bono-2',
    label: 'Bono 2',
    title: 'Tabla de requisitos legales por país',
    value: '$39',
    lead: 'Tu referencia legal en 30 segundos, para los 5 países cubiertos.',
    bullets: [
      'Altura máxima permitida en cada país',
      'Distancia mínima de personas y aglomeraciones',
      'Costos de certificación y multas por infracción',
      'Contactos directos de autoridades',
    ],
  },
  {
    id: 'bono-3',
    label: 'Bono 3',
    title: 'Diccionario técnico aeronáutico',
    value: '$19',
    lead: '300+ términos explicados en 10 segundos, para hablar el idioma de ingenieros, autoridades y clientes.',
    bullets: [
      'Aeronáutica: sustentación, drag, pitch, roll, yaw',
      'Meteorología: wind shear, índice Kp, densidad de aire',
      'Regulación: VLOS, BVLOS, NFZ, CTR, NOTAM',
      'Operación e ingeniería: IMU, ESC, gimbal, LiPo, failsafe',
    ],
  },
]
